import {apiConstructor} from '../api/ConstructorApi';

let sinks = []

//init stands list

function initSinksId() {
    return new Promise((resolve, reject) => {
        apiConstructor.getSinksId()
        .then(res => {
            sinks = res.data;
            resolve(sinks)
        })
        .catch(res => {
            reject(false)
        })
    })
}

export {sinks, initSinksId} ;